import React, { useEffect, useState } from 'react'

const WARNING_STATES = ["created", "restarting", "paused"];
const DANGER_STATES = ["exited", "dead"];

const isUnhealthy = (status) => {
  const lstatus = status?.toLowerCase() || '';
  if (lstatus.includes('unhealthy') || lstatus.includes('starting')) {
    return true;
  }
  return false;
}

const HealthIndicator = (props) => {
  const { data, url, versions, setSelectedComponent } = props;
  const [isNewestVersion, setIsNewestVersion] = useState(true);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const component = document.getElementById(`${url}-${data.name}`);
    if (component) {
      let wehrleVersion;
      Object.keys(versions).forEach(container => { if (container === data.name) wehrleVersion = versions[container] })
      if (wehrleVersion !== data.version) {
        setIsNewestVersion(false);
        component.classList.add("otherVersion");
      }

      if (isUnhealthy(data.status)) {
        component.classList.add("info");
      } else {
        component.classList.remove("info")
      }

      if (WARNING_STATES.includes(data.state)) {
        component.classList.add("warning");
      } else {
        component.classList.remove("warning")
      }

      if (DANGER_STATES.includes(data.state)) {
        component.classList.add("danger");
      } else {
        component.classList.remove("danger")
      }
    }
  }, [data.name, data.state, data.status, data.version, url, versions]);

  /**
   * Remove the docker prefix for a container name like '0a93c2b1681d_adminMongo' -> 'adminMongo'
   * but not for 'traefik_proxy_1'
   * @param name - ISystemHealth
   * @returns ISystemHealth
   * */
  const removePrefixFromDataName = (name) => {
    const parsedName = name.replace(/^[a-z0-9]{11,}_/, "");
    return parsedName;
  };

  const getColContent = () => {
    if (isHovered && !isNewestVersion) return <div className='row'>{removePrefixFromDataName(data.name)}</div>
    if (isHovered || !isNewestVersion) return <div className='row'>{data.version?.replace(/v/, '')}</div>
    if (isNewestVersion) return <div className='row'>{removePrefixFromDataName(data.name)}</div>
  }

  return <div
    onClick={() => setSelectedComponent({ url, container: data.name })}
    onMouseEnter={() => setIsHovered(true)}
    onMouseLeave={() => setIsHovered(false)}
    className='col green bordered' id={`${url}-${data.name}`}
    title={`${data.state} - ${data.status}`}
  >
    {getColContent()}
  </div>
}

export default HealthIndicator